import ListerTopBar from './lister-top-bar';
import { connect } from 'react-redux';
import { isSwipingInboxExperienceSelector } from 'app/Sections/inbox-lister/selectors';

const mapStateToProps = (state) => ({
  isSwipingToggleActive: isSwipingInboxExperienceSelector(state),
});

export default connect(mapStateToProps)(ListerTopBar);
